export default "__VITE_ASSET__Dwyimct1__"